import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { Box, ThemeProvider } from '@mui/material'
import SEO from '@talentinc/gatsby-theme-ecom/components/SEO'
import Hreflang from '@talentinc/gatsby-theme-ecom/components/Hreflang/Hreflang'
import { PageContextType } from '@talentinc/gatsby-theme-ecom/types/page'
import HeaderV2 from '@talentinc/gatsby-theme-ecom/components/HeaderV2/HeaderV2'
import Layout from '@talentinc/gatsby-theme-ecom/components/Layout'
import { TopLandingTheme } from '@talentinc/gatsby-theme-ecom/themes/top/landing'

interface Props {
  children: React.ReactNode
  pageData: any
  pageContext: PageContextType
}

const BlogLayout: React.FC<Props> = ({ children, pageData, pageContext = {} }) => {
  const { classes } = useStyles()
  const hreflangs = pageContext.hreflangs || []
  // useCheckoutEvent(landingPage)

  return (
    <Layout pageTitle={pageData.title} pageData={pageData}>
      <Box className={classes.container} component="main">
        <ThemeProvider theme={TopLandingTheme}>
          <Box className={classes.containerInner}>
            <Hreflang data={hreflangs} />
            <SEO blogPage={pageData} noIndex={pageContext.noIndex} />
            <HeaderV2 />
            {children}
          </Box>
        </ThemeProvider>
      </Box>
    </Layout>
  )
}

const useStyles = makeStyles()((theme) => ({
  container: {
    maxWidth: '100%',
    width: '100%',
  },
  containerInner: {
    maxWidth: '100%',
    width: '100%',
  },
}))

export default BlogLayout
